export const SEVERITY_MAX = 5;
export const BELOW_THRESHOLD_SEVERITY = 2;